module.exports = __webpack_public_path__ + "img/20200623-3.b2ef4855.jpg";